import React from "react";
import { HtmlTooltip, StyledStack } from "../StyledComponents/styled";
import { ExpandCircleDown } from "@mui/icons-material";

const LoadMoreButton = ({ clickAction, iconFontSize = "4em" }) => {
  return (
    <StyledStack>
      <HtmlTooltip title="More results">
        <a
          href="javacript:void(0)"
          onClick={(e) => {
            e.preventDefault();
            clickAction();
          }}
        >
          <ExpandCircleDown sx={{ cursor: "pointer", fontSize: iconFontSize, color: "#AF3241" }} />
        </a>
      </HtmlTooltip>
    </StyledStack>
  );
};

export default LoadMoreButton;
